var _SHAPES_COMPONENT_MAP;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Circular from './Circular';
import Linear from './Linear';
import * as constants from './constants';
var SHAPES_COMPONENT_MAP = (_SHAPES_COMPONENT_MAP = {}, _defineProperty(_SHAPES_COMPONENT_MAP, constants.SHAPE_CIRCULAR, Circular), _defineProperty(_SHAPES_COMPONENT_MAP, constants.SHAPE_LINEAR, Linear), _SHAPES_COMPONENT_MAP);

var AccessibleIndicator = function AccessibleIndicator(_ref) {
  var progress = _ref.progress,
      type = _ref.type;
  var value = null;
  var max = null;

  if (type === constants.TYPE_DETERMINATE) {
    value = progress;
    max = 100;
  }

  return React.createElement("progress", {
    className: "eds-is-hidden-accessible",
    value: value,
    max: max
  });
};

var ProgressIndicator =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ProgressIndicator, _React$PureComponent);

  function ProgressIndicator() {
    _classCallCheck(this, ProgressIndicator);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProgressIndicator).apply(this, arguments));
  }

  _createClass(ProgressIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          shape = _this$props.shape,
          type = _this$props.type,
          style = _this$props.style,
          progress = _this$props.progress;
      var ProgressIndicatorShape = SHAPES_COMPONENT_MAP[shape];
      return React.createElement("div", null, React.createElement(ProgressIndicatorShape, {
        size: size,
        shape: shape,
        type: type,
        style: style,
        progress: progress
      }), React.createElement(AccessibleIndicator, {
        progress: progress,
        type: type
      }));
    }
  }]);

  return ProgressIndicator;
}(React.PureComponent);

_defineProperty(ProgressIndicator, "propTypes", {
  /**
  * size and stroke of the loader
  * (small-thin, small-chunky, large-thin, large-chunky)
  */
  size: PropTypes.oneOf(constants.SIZE_NAMES),

  /**
  * shape of the loader (linear | circular)
  */
  shape: PropTypes.oneOf(constants.SHAPES),

  /**
  * Type of indicator for the loader (indeterminate | determinate)
  */
  type: PropTypes.oneOf(constants.TYPES),

  /**
  * Style of the loader (dark | light | gradient | progress)
  */
  style: PropTypes.oneOf(constants.STYLES),

  /**
  * Progress bar if the chosen Type is determinate
  */
  progress: PropTypes.number
});

_defineProperty(ProgressIndicator, "defaultProps", {
  size: constants.SIZE_LARGE_CHUNKY,
  shape: constants.SHAPE_CIRCULAR,
  type: constants.TYPE_INDETERMINATE,
  style: constants.STYLE_DARK,
  progress: 0
});

export { ProgressIndicator as default };